/**
 * @format
 */

import { UserData } from '../types/users.types';

export interface User {
  role?: string;
  officeId?: string;
  officeDownLines?: {
    downlines: Array<{ officeId: string; name: string }>;
  };
}

/**
 * Get office IDs to fetch users for based on user role and current selection
 * - root_user: can see all users (returns selected officeId if any)
 * - admin: can see users from their office and downlines
 * - agent: can see users from their office
 */
export const getOfficeIdsForUsersFetch = (
  user: User | null,
  selectedOfficeId?: string
): string[] => {
  if (!user) return [];

  const officeIds: string[] = [];

  if (user.role === 'root_user') {
    // Root user can see all users, optionally filtered by selected office
    if (selectedOfficeId) {
      officeIds.push(selectedOfficeId);
    }
  } else {
    // Admin/agent: add their own office
    if (user.officeId) {
      officeIds.push(user.officeId);
    }

    // Admin: add downline offices
    if (user.role === 'admin' && user.officeDownLines?.downlines) {
      user.officeDownLines.downlines.forEach((downline) => {
        if (downline.officeId) {
          officeIds.push(downline.officeId);
        }
      });
    }

    // If a specific office is selected and not already included
    if (selectedOfficeId && !officeIds.includes(selectedOfficeId)) {
      officeIds.push(selectedOfficeId);
    }
  }

  return officeIds;
};

/**
 * Sort users by ID in descending order
 */
export const sortUsersByIdDesc = (users: UserData[]): UserData[] => {
  return [...users].sort((a, b) => {
    return a._id > b._id ? -1 : 1;
  });
};

/**
 * Filter users to only show active users
 */
export const filterActiveUsers = (users: UserData[]): UserData[] => {
  return users.filter((user) => user.statusActive);
};
